var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{staticClass:"button is-primary next-button rolltext-button",attrs:{"as":"button"},on:{"click":function($event){return _vm.nextStep()}}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.firstline+_vm.arrow)}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.secondline + _vm.arrow)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }